import React from "react";
import {RTEWrapper, WrappedItem} from "BaseComponents/Wrappers";
import {H3} from "BaseComponents/Text";
import styled from "styled-components";
import {Image} from "BaseComponents/Image";
import {ButtonText, PrimaryButton} from "Buttons";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {useGlobal} from "reactn";

export const InfoItem = ({Heading, ResponsiveImage, Text, Link}) => {
  const [theme] = useGlobal("theme");

  let responsiveImage = getResponsiveImage(ResponsiveImage);
  let alt = ResponsiveImage.Alt;
  const addImageAttributes = alt && alt.length > 0 ? {role: "img", "aria-label": alt} : {"aria-hidden": "true"};
  return (
    <WrappedItem
      justifyContent="space-between"
      alignItems="center"
      background="white"
      margin="15px"
      padding="30px 20px"
      border={`1px solid ${theme.colors.grey}`}
      smallPadding="20px"
      className={"wrappedItem"}
    >
      <TopWrapper>
        <Image
          size="200px"
          smallSize="160px"
          borderRadius="50%"
          bgImage={responsiveImage}
          {...addImageAttributes}
        />
        <H3 margin="30px 0 0 0" textAlign="center">
          {Heading}
        </H3>
        <RTEWrapper
          textAlign="center"
          margin="10px 0 0 0"
          color="black"
          dangerouslySetInnerHTML={{__html: Text}}
        />
      </TopWrapper>
      {Link && (
        <PrimaryButton
          smallmargin="5px 0 0 0"
          widthsmall="auto"
          minwidthsmall="220px"
          href={Link.Url}
          ariaLabel={Heading}
          target={Link?.Target ?? '_self'}
        >
          <ButtonText paddingsmall="0 2rem" heading={Heading}>
            {Link.Name}
          </ButtonText>
        </PrimaryButton>
      )}
    </WrappedItem>
  );
};

const TopWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`;
